var React = require('react');

function TableIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"vector","d":"M1.5 14C1.04167 14 0.677083 13.8646 0.40625 13.5938C0.135417 13.3229 0 12.9583 0 12.5V1.5C0 1.04167 0.135417 0.677083 0.40625 0.40625C0.677083 0.135417 1.04167 0 1.5 0H12.5C12.9583 0 13.3229 0.135417 13.5938 0.40625C13.8646 0.677083 14 1.04167 14 1.5V12.5C14 12.9583 13.8646 13.3229 13.5938 13.5938C13.3229 13.8646 12.9583 14 12.5 14H1.5ZM6.25 9.25H1.5V12.5H6.25V9.25ZM7.75 9.25V12.5H12.5V9.25H7.75ZM6.25 7.75V4.5H1.5V7.75H6.25ZM7.75 7.75H12.5V4.5H7.75V7.75ZM1.5 3H12.5V1.5H1.5V3Z","fill":"#33445E"}));
}

TableIcon.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = TableIcon;

TableIcon.default = TableIcon;
